import { createSavedLayerPointFeatureStyle } from 'cadenza/map/routing/layer/waypoint-feature-style';
import { DEFAULT_OL_Z_INDEX } from 'cadenza/map/style/create-style';

/**
 * Route way point style provider
 *
 * @param {object} style - A style DTO
 * @param {GeometryType} geometryType - A feature geometry type
 * @return {Function} If style has a 'routeWayPoint' returns a waypoint style function, or undefined otherwise.
 */
export function routeWayPointStyleProvider (style, geometryType, mapPixelRatio) {
  if (!('routingWayPoint' in style)) {
    return undefined;
  }

  return feature => {
    const letter = feature.get('letter');
    const opacity = style.foregroundColorOpacity ?? 1;
    const olStyle = createSavedLayerPointFeatureStyle(
      letter,
      opacity,
      style.waypointType,
      mapPixelRatio);
    olStyle.setZIndex(DEFAULT_OL_Z_INDEX); // so the waypoint is on the same level as default styles in create-styles.js
    return olStyle;
  };
}
